import React, { Component, useState } from "react";
import $ from "jquery";
import { Redirect } from "react-router-dom";
import { Link } from "react-router-dom";
import Httpconfig from "../helpers/HttpconfigDiagnostics";
import Constant from "../../constants";
import { FormattedMessage, IntlProvider } from "react-intl";
import { I18nPropvider, LOCALES } from "../../i18nProvider";
import translate from "../../i18nProvider/translate";
import RetailerCss from "../../public/css/retailer/retailer_style.css";

export default class DiagnosisMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPromotionsSubmenu: false,
      Retailerprofile: "",
      RetailerDashboard: "",
      Retailerstock: "",
      RetailertransactionHistory: "",
      RetailerSettings: "",
      RetailerViewwallertReport: "",
      Coupons: "",
      Banners: "",
      Categories: "",
      slots: "",
    };
  }
  //Redirect to retailer profile page
  viewRetailerprofile = () => {
    window.location.href = Constant.imgurl + "/diagnostics/Retailerprofile";
  };
  //Redirect to retailer Dashboard page
  viewRetailerDashboard = () => {
    window.location.href = Constant.imgurl + "/diagnostics/Diagnosisdashboard";
  };
  //Redirect to retailer stock page
  viewStock = () => {
    window.location.href = Constant.imgurl + "/diagnostics/Diagnosistest";
  };
  //Redirect to retailer transaction history page
  viewtransactionHistory = () => {
    window.location.href =
      Constant.imgurl + "/diagnostics/DiagnosistransactionHistory";
  };
  //Redirect to retailer settings
  viewsettings = () => {
    window.location.href = Constant.imgurl + "/diagnostics/Diagnosissettings";
  };
  Viewagents = () => {
    window.location.href = Constant.imgurl + "/diagnostics/Viewagents";
  };
  //Redirect to retailer wallert reports
  viewRetailerViewwallertReport = () => {
    window.location.href = Constant.imgurl + "/RetailerViewwallertReport";
  };
  componentDidMount = () => {
    let url_path = window.location.pathname;
    let pages = url_path.split("/");
    var page = pages[2];

    var obj = {};
    obj[page] = "active";
    this.setState({
      page: page,
    });
    //checking page rendered
    if (page == "Retailerprofile") {
      this.state.Retailerprofile = "active";
    }
    if (page == "Retailerdashboard" || page == "retailerpendingorders") {
      this.state.RetailerDashboard = "active";
    }
    if (page == "Retailerstock") {
      this.state.Retailerstock = "active";
    }
    if (page == "RetailertransactionHistory") {
      this.state.RetailertransactionHistory = "active";
    }
    if (page == "Retailersettings") {
      this.state.RetailerSettings = "active";
    }
    if (page == "RetailerViewwallertReport") {
      this.state.RetailerViewwallertReport = "active";
    }
    if (page == "Viewagents") {
      this.state.Viewagents = "active";
    }

    // promotions submenu active handling (mirror RetailerSideMenu logic)
    if (
      page === "RetailerViewwallertReport" ||
      page === "Coupons" ||
      page === "Banners" ||
      page === "slots" ||
      page === "slotsConfigurations" ||
      page === "ViewRetailercoupons" ||
      page === "Retailercoupons" ||
      page === "ViewDiagnosticscoupons" ||
      page === "Diagnosticscoupons" ||
      page === "ViewDiagnosticsBanners" ||
      page === "DiagnosticsBanners" ||
      page === "ViewRetailerCategories" ||
      page === "RetailerCategories" ||
      page === "ViewRetailerBanners" ||
      page === "RetailerBanners"
    ) {
      this.setState({
        RetailerViewwallertReport: "active",
        showPromotionsSubmenu: true,
      });
      if (page === "ViewRetailercoupons" || page === "ViewDiagnosticscoupons")
        this.setState({ Coupons: "active" });
      if (
        page === "Banners" ||
        page === "ViewRetailerBanners" ||
        page === "RetailerBanners" ||
        page === "ViewDiagnosticsBanners" ||
        page === "DiagnosticsBanners"
      )
        this.setState({ Banners: "active" });
      if (page === "Retailercoupons" || page === "Diagnosticscoupons")
        this.setState({ Coupons: "active" });
      if (page === "ViewRetailerCategories" || page === "RetailerCategories")
        this.setState({ Categories: "active" });
      if (page === "slots" || page === "slotsConfigurations") {
        this.setState({ slots: "active" });
      }
    }
    this.forceUpdate();
  };
  togglePromotionsSubmenu = () => {
    this.setState((prevState) => ({
      showPromotionsSubmenu: !prevState.showPromotionsSubmenu,
    }));
  };
  render() {
    return (
      <div class="container-fluid">
        <div class="row">
          <nav id="side_Nav" class="col-lg-2 col-md-2">
            <ul>
              <li
                class={
                  this.state.RetailerDashboard != ""
                    ? this.state.RetailerDashboard
                    : ""
                }
                onClick={this.viewRetailerDashboard}
              >
                <img
                  src={Constant.imgurl + "/images/retailer/manageOrder.svg"}
                />
                <p>Manage Tests</p>
              </li>
              <li
                class={
                  this.state.Retailerstock != "" ? this.state.Retailerstock : ""
                }
                onClick={this.viewStock}
              >
                <img
                  src={Constant.imgurl + "/images/retailer/manageStock.svg"}
                />
                <p>Diagnosis Tests</p>
              </li>
              <li
                class={`${this.state.RetailerViewwallertReport} ${
                  this.state.showPromotionsSubmenu ? "open" : ""
                }`}
              >
                <div onClick={this.togglePromotionsSubmenu}>
                  <img
                    src={Constant.imgurl + "/images/retailer/manageOrder.svg"}
                  />
                  <p>Promotions</p>
                  <span className="submenu-toggle-icon">
                    {this.state.showPromotionsSubmenu ? "▼" : "▶"}
                  </span>
                </div>
                {this.state.showPromotionsSubmenu && (
                  <ul>
                    <li class={this.state.Banners}>
                      <Link to="/diagnostics/ViewDiagnosticsBanners">
                        <img
                          src="../images/retailer/banner.svg"
                          style={{ width: "0px", marginRight: "5px" }}
                        />
                        <p>Banners</p>
                      </Link>
                    </li>
                    <li class={this.state.Coupons}>
                      <Link to="/diagnostics/ViewDiagnosticscoupons">
                        <img
                          src="../images/retailer/coupon.svg"
                          style={{ width: "0px", marginRight: "5px" }}
                        />
                        <p>Coupons</p>
                      </Link>
                    </li>

                    <li class={this.state.Categories}>
                      <Link to="/diagnostics/ViewDiagnosticsCategories">
                        <img
                          src="../images/retailer/offer.svg"
                          style={{ width: "0px", marginRight: "5px" }}
                        />
                        <p>Categories</p>
                      </Link>
                    </li>
                    <li class={this.state.slots}>
                      <Link to="/diagnostics/slots">
                        <img
                          src="../images/retailer/banner.svg"
                          style={{ width: "0px", marginRight: "5px" }}
                        />
                        <p>Slots</p>
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
              <li
                class={
                  this.state.RetailertransactionHistory != ""
                    ? this.state.RetailertransactionHistory
                    : ""
                }
                onClick={this.viewtransactionHistory}
              >
                <img
                  src={Constant.imgurl + "/images/retailer/transactions.svg"}
                />
                <p>Transactions</p>
              </li>
              <li
                class={
                  this.state.Retailersettings != ""
                    ? this.state.Retailersettings
                    : ""
                }
                onClick={this.viewsettings}
              >
                <img src={Constant.imgurl + "/images/retailer/settings.svg"} />
                <p>Settings</p>
              </li>
              <li
                class={this.state.Viewagents != "" ? this.state.Viewagents : ""}
                onClick={this.Viewagents}
              >
                <img src={Constant.imgurl + "/images/retailer/agent.png"} />
                <p>Create Agent</p>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    );
  }
}
